const validate = value => {
  let regex = /^((\d{4}))$/
  if (!regex.test(value)) {
    return false
  }
  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'The number consists of the last 4 digits of your meter'
  }
}
